import { administracionAccionesRoles } from '../../acciones-roles/administracion/administracion-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton1,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';
import { humanResourcesAccionesRoles } from '../../acciones-roles/administracion/human-resources.roles';
import { HumanResourcesRoutes } from './human-resources.routes';

export const AdminitracionRoutes: SideBarButton = {
  data: {
    name: 'Administracion',
  },
  options: PreConfigButton1,
  icon: 'admin_panel_settings',
  butons: [
    {
      data: {
        name: 'Planificacion',
        url: '/management',
        roles: [...administracionAccionesRoles.sideNavActions.filterList],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Ordenes cerradas en NetSuite',
        url: '/management/closed-in-netsuite',
        roles: ['Admin'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Listado de Personal',
        url: '/users',
        avoidRoles: humanResourcesAccionesRoles.routerActions.root,
        otherUrls: ['/users/info/:userId'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Listado de Competencias',
        url: '/users/competences',
        roles: [...humanResourcesAccionesRoles.sideNavActions.competenceList],
        avoidRoles: humanResourcesAccionesRoles.routerActions.root,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Registrar Competencias',
        url: '/users/register-competence',
        avoidRoles: humanResourcesAccionesRoles.sideNavActions.competenceList,
      },
      options: PreConfigButton3,
    },
    HumanResourcesRoutes,
    {
      data: {
        name: 'Eficiencias',
        url: '/efficiencies',
        exact: false,
        otherUrls: ['/efficiencies/revisions/:id/review'],
        otherUniqueUrls: ['/efficiencies/revisions'],
        roles: administracionAccionesRoles.sideNavActions.eficiencies,
      },
      options: PreConfigButton3,
    },
  ],
};
